import { ReactNode } from "react";

import { ListCard } from "@/components/responsive-list";
import { cn } from "@/lib/utils";
import { PROJECT_PHASE_STATUS_LABEL, type ProjectPhase } from "@buildpy/core/modules/project/types";
import { PHASE_STATUS_CLASS } from "@/modules/project/ui/phase-status-class";
import PhaseStatusControl from "@/modules/project/ui/phase-status-control";

interface Props {
  phase: ProjectPhase;
  // 그 회사에게 보이는 공정 이름.
  name: string;
  // 상태 버튼을 붙일 현장 — null 이면 읽기만.
  editableProjectId: string | null;
  // 공정표 순서(1부터) — 오늘 기록처럼 일부만 보일 때는 뺀다.
  order?: number;
  // 이름 줄과 버튼 줄 사이에 넣을 것(실적·판정·사유).
  children?: ReactNode;
  // 상태 버튼 testid 앞부분 — 표와 같이 그려지는 자리(상세 공정표)만 넘긴다.
  testIdPrefix?: string;
}

// 공정 한 장 — 이름·상태·계획 날짜 한 줄, 그 아래 상태 버튼 한 줄. 오늘 기록과 현장 상세(폰)가 같이 쓴다(#22).
const PhaseCard = ({ phase, name, editableProjectId, order, children, testIdPrefix }: Props) => (
  <ListCard testId={`phase-card-${phase.id}`}>
    <div className="flex min-w-0 flex-wrap items-baseline gap-x-2 gap-y-0.5">
      {order !== undefined && <span className="tabular-nums text-muted-foreground">{order}</span>}
      <span className="min-w-0 break-words font-medium">{name}</span>
      <span className={cn("whitespace-nowrap text-xs", PHASE_STATUS_CLASS[phase.status])}>
        {PROJECT_PHASE_STATUS_LABEL[phase.status]}
      </span>
      {phase.start_date && phase.end_date && (
        <span className="ml-auto whitespace-nowrap text-xs tabular-nums text-muted-foreground">
          {`${phase.start_date.slice(5)}~${phase.end_date.slice(5)}`}
        </span>
      )}
    </div>
    {children}
    {editableProjectId && (
      <PhaseStatusControl
        schedule={phase}
        phaseId={phase.id}
        phaseName={name}
        projectId={editableProjectId}
        status={phase.status}
        testIdPrefix={testIdPrefix}
      />
    )}
  </ListCard>
);

export default PhaseCard;
